import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-bootstrap'
import { Tooltip } from "@mui/material";
import axios from '../../API/axios';
import { post } from '../../config/imagesLink';
import DraftInteraction from './DraftInteraction';
import { icons, JobSearch } from '../../config/imagesLink';
import JobDraftInteraction from './JobDraftInteraction';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { ShimmerDiv, ImageWithLoader } from "@skeleton";
import PostComponent from '../NewsFeed/PostComponent';
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import { useTranslation } from 'react-i18next';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import WorkOutlineSharpIcon from '@mui/icons-material/WorkOutlineSharp';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import JobStatusBadges from '../../components/JobStatusBadges';
import '../JobSearch/JobSearchRedesign.css';

const DRAFT_TAB_MAP = {
    postdrafts: 1,
    jobdrafts: 2,
};

const DRAFT_TAB_ROUTES = {
    1: "PostDrafts",
    2: "JobDrafts",
};

const getDraftTabIndex = (routeTab) => {
    const tabKey = (routeTab || "").toLowerCase();
    return DRAFT_TAB_MAP[tabKey] || 1;
};

const Draft = () => {
      const { t } = useTranslation();
    
    const sessionId = localStorage.getItem("sessionId");
    const location = useLocation();
    const navigate = useNavigate();
    const { tab } = useParams();
    const [activeTab, setActiveTab] = useState(() => getDraftTabIndex(tab));

    const goToDraftTab = (tabIndex) => {
        setActiveTab(tabIndex);
        const tabPath = DRAFT_TAB_ROUTES[tabIndex];
        if (tabPath) {
            navigate(`/Draft/${tabPath}`);
        }
    };

    //************************ Draft Job Start  ************************//
    const [draftJob, setDraftJob] = useState([]);
    const [isLoadingJob, setIsLoadingJob] = useState(false);
    const language = localStorage.getItem("Lang");
  const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";
    const [isPostDraftError, setIsPostDraftError] = useState(false);
    console.log('draftJob', draftJob);

    const DraftJob = async () => {
        const Data = {
            "deviceType": "Web",
            "sessionId": sessionId,
            langKey: language === "en" ? "" : language,
        }
        try {
            setIsLoadingJob(true)
            await axios.post(`/Job/GetAllDraftJobs`, Data).then((resData) => {
                console.log('resData', resData);
                if (resData?.status === 204) {
                    setIsError(true)
                } else {
                    setDraftJob(resData.data.responseData)
                }
                setIsLoadingJob(false);
            });
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setIsError(true);
            } else {
                console.log(error);
            }
            setIsLoadingJob(false);
        }
    };


    //************************ Draft Job End  ************************//

    //************************ Draft Post Start  ************************//

    const [draftPost, setDraftPost] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const DraftPost = async () => {
        const Data = {
            "deviceType": "Web",
            "sessionId": sessionId,
            langKey: language === "en" ? "" : language,
        }
        try {
            setIsLoading(true);
            await axios.post(`/Posts/GetDraftPosts`, Data).then((resData) => {
                setIsLoading(false);
                console.log('GetDraftPosts', resData.data.responseData);
                const data = resData.data.responseData.reverse()
                setDraftPost(data)
            });
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setIsPostDraftError(true);
            } else {
                console.log(error);
            }
            console.log(error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        DraftPost();
        DraftJob()

    }, []);
    //************************ Draft Post End  ************************//

    // Helper function for regex escaping
    const escapeRegex = (str) => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };

    // Helper function to normalize dynamic values from API
    const normalizeDynamicValues = (dynamicValues = []) => {
        return (dynamicValues || []).map((dv, idx) => {
            if (!dv) return null;

            const {
                type,
                dVno,
                entity,
                entityID,
                entityId,
                userUid,
                displayName,
                display,
                entityName,
                hashTag,
            } = dv;

            const resolvedType = type || (hashTag ? "Hashtag" : "UserMention");
            const resolvedDisplayName = displayName ?? display ?? entityName ?? hashTag ?? "";

            let resolvedEntity = entity ?? entityID ?? entityId ?? userUid ?? hashTag ?? resolvedDisplayName;

            if (resolvedType === "Hashtag") {
                resolvedEntity = resolvedDisplayName;
            }

            return {
                type: resolvedType,
                dVno: dVno ?? idx + 1,
                entity: resolvedEntity,
                display: resolvedDisplayName,
                displayName: resolvedDisplayName,
            };
        }).filter(Boolean);
    };

    // Helper function to replace {n} placeholders with @mention/#hashtag
    const replaceDynamicValues = (content, dynamicValues = []) => {
        if (!content) return content;

        let result = content;
        const safeDynamicValues = Array.isArray(dynamicValues) ? dynamicValues : [];

        safeDynamicValues.forEach((item) => {
            const placeholder = `{${item.dVno}}`;
            const displayName = item.display ?? item.displayName ?? "";
            let replacement = "";

            if (item.type === "UserMention" || item.type === "CompanyMention") {
                replacement = `@${displayName}`;
            } else if (item.type === "Hashtag") {
                replacement = `#${displayName}`;
            } else {
                replacement = displayName;
            }

            result = result.replaceAll(placeholder, replacement);
        });

        return result;
    };

    // Convert mentions to clickable links (for display only)
    const convertMentionsToLinks = (content, dynamicValues) => {
        let modified = content;
        const ensureArray = (val) => (Array.isArray(val) ? val : []);

        ensureArray(dynamicValues).forEach(
            ({ type, displayName, display, entity }) => {
                const prefix =
                    type === "UserMention" || type === "CompanyMention"
                        ? "@"
                        : "#";

                const name = display || displayName;
                const fullText = `${prefix}${name}`;

                const link =
                    type === "UserMention" || type === "CompanyMention"
                        ? `/profile/${entity}`
                        : `/hashtag/${name}`;

                const regex = new RegExp(
                    escapeRegex(fullText) + "(?![^<]*>)",
                    "g"
                );

                modified = modified.replace(
                    regex,
                    `<a href="${link}" target="_blank" class="mention-link">${fullText}</a>`
                );
            }
        );

        return modified;
    };

    const addTargetBlankToAnchors = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;

        const anchors = div.querySelectorAll('a');
        anchors.forEach(anchor => {
            anchor.setAttribute('target', '_blank');
            anchor.setAttribute('rel', 'noopener noreferrer');
        });

        return div.innerHTML;
    };

    const linkifyContent = (htmlContent) => {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
        return htmlContent.replace(urlPattern, function (url) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
    };

    const cleanShortDescription = (htmlString) => {
        return htmlString
            ?.replace(/<h3>/gi, "<div>")
            ?.replace(/<\/h3>/gi, "</div>")
            ?.replace(/<strong>/gi, "")
            ?.replace(/<\/strong>/gi, "");
    };

    // change page scroll top

    useEffect(() => {
        if (location.pathname === "/Draft") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [location.pathname]);


    const renderTabContent = () => {
        switch (activeTab) {
            case 1:
                return (
                    <>
                        {isLoading ? (
                            <div className="mt-3">
                                <ShimmerDiv height={200} width={'100%'} className='mb-2' />
                                <ShimmerDiv height={200} width={'100%'} className='mb-2' />
                                <ShimmerDiv height={200} width={'100%'} className='mb-2' />
                                {/* <ShimmerThumbnail height={250} rounded width={"50px"} />
                                <ShimmerThumbnail height={250} rounded width={"50px"} />
                                <ShimmerThumbnail height={250} rounded width={"50px"} /> */}
                            </div>
                        )
                            : isPostDraftError || draftPost.length === 0 ? (
                                <div className="mt-2 error-image-cont error-connection">
                                    <img src={post.errorSmall} alt="404 Not Found" />
                                </div>
                            ) : (
                                draftPost &&
                                draftPost
                                    .filter((item) => !item.isDeleted)
                                    ?.map((item, index) => {
                                           const now = moment.utc().local();
                                                            const itemTime = moment.utc(item?.postInfo?.creationTime).local();
                                                            const diffSeconds = now.diff(itemTime, "seconds");
                                                            const diffMinutes = now.diff(itemTime, "minutes");
                                                            const diffHours = now.diff(itemTime, "hours");
                                                            const diffDays = now.diff(itemTime, "days");
                                        
                                                            const diffMonths = now.diff(itemTime, "months", true);
                                                            const diffYears = now.diff(itemTime, "years", true);
                                        
                                                            let result = "";
                                        
                                                            /* JUST NOW */
                                                            if (diffSeconds < 60) {
                                                              result = t("Notifications.Just Now");
                                                            }
                                        
                                                            /* MINUTES */
                                                            else if (diffMinutes < 60) {
                                                              result =
                                                                diffMinutes === 1
                                                                  ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                                                                  : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                                                            }
                                        
                                                            /* HOURS */
                                                            else if (diffHours < 24) {
                                                              result =
                                                                diffHours === 1
                                                                  ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                                                                  : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                                                            }
                                        
                                                            /* DAYS */
                                                            else if (diffDays < 30) {
                                                              result =
                                                                diffDays === 1
                                                                  ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                                                                  : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                                                            }
                                        
                                                            /* MONTHS */
                                                            else if (diffMonths < 12) {
                                                              const displayMonth =
                                                                diffMonths >= 0.75 && diffMonths < 1.25
                                                                  ? 1
                                                                  : Math.round(diffMonths * 2) / 2;
                                        
                                                              result =
                                                                displayMonth === 1
                                                                  ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                                                                  : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                                                            }
                                        
                                                            /* YEARS */
                                                            else {
                                                              const displayYear =
                                                                diffYears >= 0.75 && diffYears < 1.25
                                                                  ? 1
                                                                  : Math.round(diffYears * 2) / 2;
                                        
                                                              result =
                                                                displayYear === 1
                                                                  ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                                                                  : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                                                            }
                                        
                                        
                                        console.log('draftPost', item);
                                        return (
                                            <div className="featured-card user-postOnlyContent draftPost p-2 mb-3 m-auto"
                                                key={index}

                                            >
                                                <div className="feature-content p-2 d-flex justify-content-between">
                                                    <Link to={`/User/${item?.postInfo?.userUid}`}>
                                                        <div className="d-flex align-items-center">
                                                            <div className="ImgAvatar">
                                                                <img src={item?.postInfo?.userAvatar} alt="" style={{ borderRadius: '50px' }} />
                                                            </div>
                                                            <div className="ms-2">
                                                                <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.userName}</h4>
                                                                {/* <p className="f-12">
                                                                    {moment
                                                                        .utc(item?.postInfo?.creationTime)
                                                                        .local()
                                                                        .format("DD MMMM YYYY [at] h:mm a")}
                                                                </p> */}
                                                            {language === "ar" ? (
                                                                <Tooltip title={moment
                                                                        .utc(item?.postInfo?.creationTime)
                                                                        .locale(locale)
                                                                        .local()
                                                                        .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                                    <p className="f-10 label"> 
                                                                        {moment
                                                                        .utc(item?.postInfo?.creationTime)
                                                                        .locale(locale)
                                                                        .local()
                                                                        .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                                    </p>
                                                                </Tooltip>
                                                                ) : (
                                                                <Tooltip title={moment
                                                                        .utc(item?.postInfo?.creationTime)
                                                                        .local()
                                                                        .format(language === "en"
                                                                            ? "D MMMM YYYY [at] h:mm a"
                                                                            :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                                    <p className="f-10 label"> 
                                                                        {result}
                                                                        {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                                    </p>
                                                                </Tooltip>
                                                                    

                                                                )}                                                                
                                                            </div>
                                                        </div>
                                                    </Link>
                                                    {/* <div className="d-flex align-items-center">
                                                        <div className="ImgAvatar">
                                                            <img src={NewsFeed.companyLogo} alt="" />
                                                        </div>
                                                        <div className="ms-2">
                                                            <h4 className="f-14 fw-bold mb-0">Ahmad Nur Fawaid</h4>
                                                            <p className="f-12">12 April at 09.29 PM</p>
                                                        </div>
                                                    </div> */}
                                                    <DraftInteraction
                                                        postId={item?.postInfo?.postId}
                                                        DraftPost={DraftPost}
                                                        setDraftJob={setDraftJob}
                                                        setDraftPost={setDraftPost}
                                                        postOriginId={item?.postInfo?.postOriginId}
                                                        postOriginType={item?.postInfo?.postOriginType}
                                                    // AllPostList={AllPostList}
                                                    // postList={postList}
                                                    // setPage={setPage}
                                                    // setPostList={setPostList}
                                                    // page={page}
                                                    // setTotalPages={setTotalPages}
                                                    // totalPages={totalPages}
                                                    />
                                                </div>
                                                {/* <p className="f-14 p-2">{item?.postInfo?.postContent}</p> */}
                                                {item?.postInfo?.postContent && (
                                                    <div className="f-14 p-2 postContent">
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: (() => {
                                                                    const normalized = normalizeDynamicValues(item?.postInfo?.dynamicValues || []);
                                                                    const replaced = replaceDynamicValues(item?.postInfo?.postContent || "", normalized);
                                                                    const withLinks = convertMentionsToLinks(replaced, normalized);
                                                                    return linkifyContent(addTargetBlankToAnchors(withLinks));
                                                                })()
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                                {/* <PostComponent item={item} /> */}

                                                <div className="feed-post p-2">
                                                    {/* <div className="row">
                                                        {item.mediaFilesList.slice(0, 4).map((file, idx) => (
                                                            <div
                                                                key={idx}
                                                                className={`col-${item.postMediaCount === 1 ? "12" : "6"
                                                                    } ${item.postMediaCount === 3 && idx === 0
                                                                        ? "col-12"
                                                                        : ""
                                                                    }`}
                                                                style={{
                                                                    position: "relative",
                                                                    padding:
                                                                        item.postMediaCount === 3 && idx === 0
                                                                            ? "0 0 5px 0"
                                                                            : item.postMediaCount === 3 && idx === 1
                                                                                ? "0 5px 5px 0"
                                                                                : item.postMediaCount === 4 && idx === 2
                                                                                    ? "0 5px 0 0"
                                                                                    : item.postMediaCount === 4 && idx === 0
                                                                                        ? "0 5px 5px 0"
                                                                                        : item.postMediaCount === 2 && idx === 0
                                                                                            ? "0 5px 5px 0"
                                                                                            : "",
                                                                }}
                                                            >
                                                                <img
                                                                    src={file.mediaName}
                                                                    alt=""
                                                                    className="img-fluid"
                                                                    width={"100%"}
                                                                />
                                                                {idx === 3 && item.postMediaCount > 4 && (
                                                                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                                                        +{item.postMediaCount - 4}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div> */}
                                                    {console.log("mediaFilesList", item?.postInfo)}
                                                    <div className="row">
                                                        {item?.postInfo?.mediaFilesList?.slice(0, Math.min(item?.postInfo?.postMediaCount, 4)).map((file, idx) => (

                                                            <div
                                                                key={idx}
                                                                className={`col-${item?.postInfo?.postMediaCount === 1 ? "12" : "6"} 
                                                               ${item?.postInfo?.postMediaCount === 3 && idx === 0 ? "col-12" : ""}`}
                                                                style={{
                                                                    position: "relative",
                                                                    padding:
                                                                        item?.postInfo?.postMediaCount === 3 && idx === 0
                                                                            ? "0 0 5px 0"
                                                                            : item?.postInfo?.postMediaCount === 3 && idx === 1
                                                                                ? "0 5px 5px 0"
                                                                                : item?.postInfo?.postMediaCount === 4 && idx === 2
                                                                                    ? "0 5px 0 0"
                                                                                    : item?.postInfo?.postMediaCount === 4 && idx === 0
                                                                                        ? "0 5px 5px 0"
                                                                                        : item?.postInfo?.postMediaCount === 2 && idx === 0
                                                                                            ? "0 5px 5px 0"
                                                                                            : "",
                                                                }}
                                                            >
                                                                {console.log("mediaFilesList", item?.postMediaCount)}

                                                                <ImageWithLoader
                                                                    src={file.mediaName}
                                                                    alt=""
                                                                    className="img-fluid"
                                                                    width={"100%"}
                                                                />

                                                                {idx === 3 && item.postInfo?.postMediaCount > 4 && (
                                                                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                                                        +{item?.postInfo?.postMediaCount - 4}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>


                                                </div>
                                                {/* <div className="postengagement">
                                                <PostEngagement
                                                    item={item}
                                                    postId={item?.postId}
                                                // AllPostList={AllPostList}
                                                // postList={postList}
                                                // setPage={setPage}
                                                // setPostList={setPostList}
                                                // page={page}
                                                // setTotalPages={setTotalPages}
                                                // totalPages={totalPages}

                                                />
                                            </div> */}

                                            </div>
                                        );
                                    })
                            )}
                    </>
                );
            case 2:
                return (
                    <div className="job-search-workspace draft-job-workspace">
                        {isLoadingJob ? (
                            <div className="row job-list-grid">
                                <div className="col-12 col-md-6 d-flex align-items-stretch mt-3 IncreaseWidthJobCard">
                                    <ShimmerDiv height={250} width="100%" rounded={4} />
                                </div>
                                <div className="col-12 col-md-6 d-flex align-items-stretch mt-3 IncreaseWidthJobCard">
                                    <ShimmerDiv height={250} width="100%" rounded={4} />
                                </div>
                            </div>
                        ) : isError || draftJob?.length === 0 ? (
                            <div className="mt-2 error-image-cont error-connection">
                                <img src={post.errorSmall} alt="404 Not Found" />
                            </div>
                        ) : (
                            <div className="row job-list-grid">
                            {(draftJob || [])
                                .filter((item) => !item.isDeleted)
                                .map((item) => {
                                    const now = moment();
                                    const itemTime = moment.utc(item?.creationTime);
                                    const duration = moment.duration(now.diff(itemTime));

                                    const years = duration.years();
                                    const months = duration.months();
                                    const days = duration.days();
                                    const hours = duration.hours();
                                    const minutes = duration.minutes();

                                    let result = "";

                                    if (years > 0) {
                                        result = `${years} ${t("Notifications.Year")}${years > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                                    } else if (months > 0) {
                                        result = `${months} ${t("Notifications.Month")}${months > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                                    } else if (days > 0) {
                                        result = `${days} ${t("Notifications.Day")}${days > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                                    } else if (hours > 0) {
                                        result = `${hours} ${t("Notifications.Hour")}${hours > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                                    } else if (minutes > 0) {
                                        result = `${minutes} ${t("Notifications.Minute")}${minutes > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                                    } else {
                                        result = t("Notifications.Just Now");
                                    }

                                    return (
                                      <div
                                        className="col-12 col-md-6 d-flex align-items-stretch mt-3 IncreaseWidthJobCard"
                                        key={item.jobId}
                                      >
                                        <div className="jobCard p-3 w-100 d-flex flex-column justify-content-between">
                                          <div>
                                            <div
                                              className="d-flex justify-content-start align-items-center job-company-row"
                                              style={{ height: "60px" }}
                                            >
                                              <Link to={item.slug ? `/Company/${item.compUid}/${item.slug}` : `/Company/${item.compUid}`}>
                                                <div className="pointer d-flex">
                                                  <img
                                                    src={item?.compLogo}
                                                    alt={`${item.compName} logo`}
                                                    className="job-company-logo"
                                                    title={item.compName}
                                                  />
                                                </div>
                                              </Link>
                                              <Link to={item.slug ? `/Company/${item.compUid}/${item.slug}` : `/Company/${item.compUid}`} className="job-company-link d-flex align-items-center">
                                                <span className="job-company-name" title={item.compName}>
                                                  {item.compName}
                                                </span>
                                                {item.isVerified ? (
                                                  <VerifiedIcon sx={{ fontSize: 16, color: "#12B76A", marginLeft: "4px" }} titleAccess="Verified" />
                                                ) : null}
                                              </Link>
                                              <div className="ms-auto">
                                                <JobDraftInteraction
                                                  DraftJob={DraftJob}
                                                  jobId={item?.jobId}
                                                  item={item}
                                                />
                                              </div>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-start mt-2 job-title-row">
                                              <Link to={`/JobDetail/${item.jobId}`} className="job-title-link">
                                                <p className="job-title pointer mb-0">
                                                  {item.title}
                                                </p>
                                              </Link>
                                            </div>

                                            <p
                                              className="short-Des-jobCard"
                                              dangerouslySetInnerHTML={{
                                                __html: cleanShortDescription(
                                                  item.shortDescription?.length > 50
                                                    ? item.shortDescription?.slice(0, 50) + "..."
                                                    : item.shortDescription
                                                ),
                                              }}
                                              style={{ fontSize: "13px", lineHeight: "1.5" }}
                                            />
                                            <div className="job-location">
                                              <LocationOnOutlinedIcon />
                                              <span>{item.cityName}</span>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-2 job-card-foot">
                                              <Tooltip title={moment.utc(item?.creationTime).local().format("DD MMM YYYY")} arrow>
                                                <small aria-label={`Posted on ${moment.utc(item?.creationTime).local().format("DD MMM YYYY")}`}>
                                                  <ScheduleOutlinedIcon />
                                                  {t("Manage Job.Posted")} {result}
                                                </small>
                                              </Tooltip>
                                              {item?.expiringInDays != null && item?.expiringInDays !== "" && (
                                                <div className="badge badge-date" aria-label={`${Number(item?.expiringInDays) < 0 ? 'expired' : 'expires in'} ${Number(item?.expiringInDays) < 0 ? Math.abs(Number(item?.expiringInDays)) : item?.expiringInDays} days`}>
                                                  {Number(item?.expiringInDays) < 0
                                                    ? `${t("Manage Job.expired")} ${Math.abs(Number(item?.expiringInDays))} ${t("Manage Job.days Ago")}`
                                                    : `${item?.expiringInDays} ${t("Manage Job.days Left")}`}
                                                </div>
                                              )}
                                            </div>

                                            <div className="jobType">
                                              <div className="badge badge-job badge-job-type">
                                                {item.jbTypName}
                                              </div>
                                              <div className="badge badge-job badge-job-location">
                                                {item.workLocationTypeName}
                                              </div>
                                              <div className="badge badge-job badge-job-role">
                                                {item.designationName}
                                              </div>
                                            </div>
                                            <JobStatusBadges item={item} />
                                          </div>
                                          <div className="mt-auto">
                                            <div className="mt-auto jobAction d-flex justify-content-between align-items-center">
                                              <Link to={`/JobDetail/${item.jobId}`}>
                                                <button className="mainBtn4">
                                                  <VisibilityOutlinedIcon />
                                                  {t("Manage Job.View")}
                                                </button>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            default:
                return null;
        }
    };

    useEffect(() => {
        setActiveTab(getDraftTabIndex(tab));
    }, [tab]);


    // -------------------------------------------------------------------------
    const { setIsNewsPageLoaded } = useNewsFeedStore();

    useEffect(() => {
        setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

        return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
    }, [setIsNewsPageLoaded]);

    // -------------------------------------------------------------------------

    return (
        <>
            <div>
                <div className="friendsHeaderText p-2 pt-0 pb-0">
                    <h1>{t("Sidemenubar.Drafts")} </h1>
                    <p className="discovery-subtitle mb-0">
                        {t("Drafts.DiscoverSubtitle", {
                            defaultValue: "Finish saved posts and jobs when you are ready to publish.",
                        })}
                    </p>
                </div>
                <div className="tabButton d-flex p-2 w-100 connectionTab wlj-tab-bar">
                    <NavLink
                        //onClick={() => setActiveTab(1)}
                        onClick={() => goToDraftTab(1)}
                        className={`text-center ${activeTab === 1 ? "activeTab" : ""}`}
                    >
                        <ArticleOutlinedIcon />
                        <p className="f-14 tabName">{t("Drafts.Post Drafts")}</p>
                    </NavLink>
                    <NavLink
                        // onClick={() => setActiveTab(2)}
                        onClick={() => goToDraftTab(2)}
                        className={`text-center ${activeTab === 2 ? "activeTab" : ""}`}
                    >
                        <WorkOutlineSharpIcon />
                        <p className="f-14 tabName">{t("Drafts.Job Drafts")} </p>
                    </NavLink>
                </div>

                <div className="resume-section">{renderTabContent()}</div>
            </div>
        </>
    )
}

export default Draft